export const Skeleton = () => {
  return (
    <div className="flex flex-col gap-y-4">
      <div className="skeleton bg-custom-gray overflow-hidden p-3 rounded-lg w-44" />
      <div className="skeleton bg-custom-gray overflow-hidden p-2 rounded-lg w-32" />
    </div>
  );
};
